import { render, staticRenderFns } from "./menungguRespon.vue?vue&type=template&id=0c32b156&scoped=true&"
import script from "./menungguRespon.vue?vue&type=script&lang=js&"
export * from "./menungguRespon.vue?vue&type=script&lang=js&"
import style0 from "./menungguRespon.vue?vue&type=style&index=0&id=0c32b156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c32b156",
  null
  
)

export default component.exports